module.exports = __webpack_public_path__ + "images/loginback_2.jpg";